import type {CopilotSpaceResource} from '../types'

// Merges and deduplicates resources.
//
// - If a new resource is a repository and there is a deleted repository with
//   the same id, it will unmark it for destruction.
export function mergeAndDedupResources(
  prevResources: CopilotSpaceResource[],
  newResources: CopilotSpaceResource[],
): CopilotSpaceResource[] {
  const resourceMap = new Map(prevResources.map(resource => [resource.id, resource]))
  // Add or update resources from newResources
  for (const newResource of newResources) {
    // Check if this is a repository type resource that already exists. If so unmark it for destruction.
    if (newResource.type === 'repository') {
      const existingRepository = prevResources.find(
        resource => resource.type === 'repository' && resource.repositoryId === newResource.repositoryId,
      )
      if (existingRepository) {
        resourceMap.set(existingRepository.id, {...existingRepository, markedForDestroy: false})
        continue
      }
    }

    // If the resource already exists and is not a repository resource, this
    // will overwrite it. Otherwise, it will add a new entry.
    resourceMap.set(newResource.id, newResource)
  }

  // Convert the Map back to an array
  return Array.from(resourceMap.values())
}
